import Link from "next/link";
import AccordionItem from "@/components/ui/AccordionItem";

export type FaqItem = {
  question: string;
  answer: string;
  cta?: { label: string; href: string };
};

export default function FaqSection({
  heading,
  items,
  headingAlign = "left",
  cardClassName = "bg-mkt-surface border border-mkt-outline-variant/30 rounded-lg overflow-hidden transition-all duration-300",
  headingClassName = "font-headline-lg text-headline-lg text-mkt-on-background mb-size-lg",
}: {
  heading: string;
  items: FaqItem[];
  headingAlign?: "left" | "center";
  cardClassName?: string;
  headingClassName?: string;
}) {
  return (
    <>
      <h2 className={`${headingClassName} ${headingAlign === "center" ? "text-center" : "text-left"}`}>{heading}</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 items-start">
        {items.map((item) => (
          <AccordionItem
            key={item.question}
            cardClassName={cardClassName}
            buttonClassName="w-full flex justify-between items-center p-size-md text-left focus:outline-none"
            contentClassName="px-size-md"
            trigger={<span className="font-headline-md text-headline-sm">{item.question}</span>}
          >
            <div className="text-mkt-on-surface-variant font-body-md pb-size-md">
              {item.answer}
              {item.cta && (
                <Link
                  className="text-mkt-primary font-label-md text-label-md border-b-2 border-mkt-primary ml-size-xs"
                  href={item.cta.href}
                >
                  {item.cta.label}
                </Link>
              )}
            </div>
          </AccordionItem>
        ))}
      </div>
    </>
  );
}
